import $http from "../../axios-instance";
import Swal from "sweetalert2";

/**
 * Buscar compañias por nombre y las setea en el store.
 *
 * @param {*string} name
 * @returns {Promise<void>}
 * @author Luis Almendrales
 */
export async function getCompany({ commit, state, rootState }, name) {
    if (name.length >= 3) {
        commit("dashboard/load", true, { root: true });
        await $http
            .get("/empresas/lista?nombre=" + name)
            .then(response => {
                commit("setCompanies", response.data.data);
                commit("dashboard/load", false, { root: true });
            })
            .catch(error => {
                commit("mensajeError", error.message);
                commit("dashboard/load", false, { root: true });
            });
    }
}

/**
 * Busca los acciendes mayores de una compañia usando el state.filter y los setea en el store.
 *
 * @returns {Promise<void>}
 * @author Luis Almendrales
 */
export async function getAccidentHigh({ commit, state, rootState }) {
    commit("dashboard/load", true, { root: true });
    await $http
        .get(
            "/slq-high-accident/list?company_id=" +
                state.filter.company.id +
                "&page=" +
                state.filter.page +
                "&perPage=" +
                state.filter.perPage +
                "&search=" +
                state.filter.search +
                "&location_id=" +
                state.filter.location_id+
                "&is_approved=" +
                state.filter.is_approved
        )
        .then(response => {
            commit("setAccidentHigh", response.data);
            commit("dashboard/load", false, { root: true });
        })
        .catch(error => {
            commit("mensajeError", error.message);
            commit("dashboard/load", false, { root: true });
        });
}

/**
 * Restablece el state.filter, state.compnay and state.locations a sus valores por defecto.
 *
 * @returns {Promise<void>}
 * @author Luis Almendrales
 */
export function resetFilterCompany({ commit, state, rootState }) {
    commit("resetValues", state);
    commit("resetNewRegister", state);
    commit("setLocations", []);
}

/**
 * Busca las ubicaciones de una compañia y las setea en el store.
 *
 * @returns {Promise<void>}
 * @author Luis Almendrales
 */
export async function getLocations({ commit, state }) {
    commit("dashboard/load", true, { root: true });
    await $http
        .get("/company/location/tree/" + state.filter.company.id)
        .then(response => {
            commit("setLocations", response.data.data);
            commit("dashboard/load", false, { root: true });
        })
        .catch(error => {
            commit("dashboard/load", false, { root: true });
        });
}

/**
 * Crea un nuevo accidente mayor.
 *
 * @param {*object {start_date,slq_location_id,description,company_id,active}} data
 * @returns {Promise<void>}
 * @author Luis Almendrales
 */
export async function createAccidentHigh({ commit, state, rootState }, data) {
    commit("dashboard/load", true, { root: true });
    await $http
        .post("/slq-high-accident/create", data)
        .then(response => {
            commit("dashboard/load", false, { root: true });
            commit("setModalCreate", false);
            commit("resetNewRegister", state);
            Swal.fire({
                title: "Accidente mayor creado",
                text: response.data.message,
                icon: "success",
                confirmButtonText: "Aceptar"
            });
        })
        .catch(error => {
            commit("dashboard/load", false, { root: true });
            Swal.fire({
                title: "Error al crear el accidente mayor",
                text: error.response.data.message,
                icon: "error",
                confirmButtonText: "Aceptar"
            });
        });
}

/**
 * Busca un accidente mayor y sus productos por su id y lo setea en el store.
 *
 * @param {*int} id: id del accidente mayor
 * @returns {Promise<void>}
 * @author Luis Almendrales
 */
export async function getAccidentHighById({ commit, state, rootState }, id) {
    commit("dashboard/load", true, { root: true });
    await $http
        .get(
            "/slq-high-accident/show/" +
                id +
                "?company_id=" +
                state.filter.company.id
        )
        .then(response => {
            response.data.active = response.data.active == 1 ? true : false;
            commit("setAccidentHighById", response.data);
            commit("dashboard/load", false, { root: true });
        })
        .catch(error => {
            commit("dashboard/load", false, { root: true });
        });
}

/**
 * Actualiza un accidente mayor.
 *
 * @param {*object {start_date,slq_location_id,description,company_id,active}} data
 * @returns {Promise<void>}
 * @author Luis Almendrales
 */
export async function updateAccidentHigh({ commit, state, rootState }, data) {
    commit("dashboard/load", true, { root: true });
    await $http
        .put("/slq-high-accident/update/" + data.id, data)
        .then(response => {
            commit("dashboard/load", false, { root: true });
            commit("setModalCreate", false);
            commit("resetNewRegister", state);
            Swal.fire({
                title: "Accidente mayor actualizado",
                text: response.data.message,
                icon: "success",
                confirmButtonText: "Aceptar"
            });
        })
        .catch(error => {
            commit("dashboard/load", false, { root: true });
            Swal.fire({
                title: "Error al actualizar el accidente mayor",
                text: error.response.data.message,
                icon: "error",
                confirmButtonText: "Aceptar"
            });
        });
}

/**
 * Busca los productos de un accidente mayor usando el state.filterProducts y los setea en el store.
 *
 * @returns {Promise<void>}
 * @author Luis Almendrales
 */
export async function getProductsByLocationId({state, commit},data) {
    try {
        commit('dashboard/load', true, {root: true});
        const payload = {
            company_id : state.filter.company.id,
            high_accident_id : data.id,
            page :  state.filterProducts.page,
            perPage :  state.filterProducts.perPage,
            search :  state.filterProducts.search,
            producer_id :  state.filterProducts.producer.id,
        }
        const response = await $http.get(`/slq-high-accident/products-details/${data.location_id}`, {params: {...payload}});
        if (response.status == 200) {
            response.data.data.data.forEach(element => {
                if (!element.producto.propiedades) {
                    element.producto.propiedades = {
                        id: null,
                        id_producto: element.producto.id,
                        flash_point_rango: 0,
                        id_um_flash_point: null,
                        flash_point: null,
                        flash_point_hasta: null,
                        punto_ebullicion_rango: 0,
                        id_um_punto_ebullicion: null,
                        punto_ebullicion: null,
                        punto_ebullicion_hasta: null
                    };
                }
            });
            commit("setProductsAccident", response.data.data);
        }

    } catch (error) {
        if (this.$vue.$alertErrorsCallback(error)) return;
        this.$vue.$alertError(error.message);
    } finally {
        commit('dashboard/load', false, {root: true});
    }
}

/**
 * Busca los productos de una ubicación que no tenga asocidados o activo al accidente mayor.
 *
 * @returns {Promise<void>}
 * @author Paul Valencia
 */
export async function getProductsByLocationWithOutHighAccident({state, commit}, data) {
    try {
        commit('dashboard/load', true, {root: true});
        const payload = {
            company_id: data.company_id,
            high_accident_id: data.id,
            page: state.filterProducts.page,
            perPage: state.filterProducts.perPage,
            search: state.filterProducts.search,
            producer_id: state.filterProducts.producer.id,
        }
        const response = await $http.get(`/slq-high-accident/products-location-without-accident/${data.location_id}`, {params: {...payload}});

        response.data.data.data.forEach(element => {
            if (!element.producto.propiedades) {
                element.producto.propiedades = {
                    id: null,
                    id_producto: element.producto.id,
                    flash_point_rango: 0,
                    id_um_flash_point: null,
                    flash_point: null,
                    flash_point_hasta: null,
                    punto_ebullicion_rango: 0,
                    id_um_punto_ebullicion: null,
                    punto_ebullicion: null,
                    punto_ebullicion_hasta: null
                };
            }
        });
        commit("setProducts", response.data.data);
    } catch (error) {
        if (this.$vue.$alertErrorsCallback(error)) return;
        this.$vue.$alertError(error.message);
    } finally {
        commit('dashboard/load', false, {root: true});
    }
}

/**
 * Busca los productos de una ubicacion que no pertenecen a las categorias ppam.
 *
 * @returns {Promise<void>}
 * @author Luis Almendrales
 */
export async function getProductNotCategoriesPpamByLocationId(
    { commit, state, rootState },
    data
) {
    commit("dashboard/load", true, { root: true });
    await $http
        .get(
            "/slq-high-accident/products-location-not-categories-ppam/" +
                data.location_id +
                "?company_id=" +
                state.filter.company.id +
                "&page=" +
                state.filterProducts.page +
                "&perPage=" +
                state.filterProducts.perPage +
                "&search=" +
                state.filterProducts.search +
                "&producer_id=" +
                state.filterProducts.producer.id
        )
        .then(response => {
            commit("setProductsNotPpam", response.data.data);
            commit("dashboard/load", false, { root: true });
        })
        .catch(error => {
            commit("dashboard/load", false, { root: true });
        });
}

/**
 * Método para obtener las unidades de medida y las setea en el store.
 *
 * @param {state, commit}
 * @returns {Promise<void>}
 * @author Luis Almendrales
 */
export async function getUnitMeasures({ state, commit }) {
    commit("dashboard/load", true, { root: true });
    await $http
        .get(`adm_general/control-por-codigo/mostrar/capall`)
        .then(response => {
            commit("dashboard/load", false, { root: true });
            commit("setUnitMeasures", response.data.data);
        })
        .catch(error => {
            commit("dashboard/load", false, { root: true });
            Swal.fire({
                position: "center",
                icon: "error",
                title: error.message + "<br />" + error.errors,
                showConfirmButton: true,
                timer: 5000
            });
        });
}

/**
 * Método para obtener las unidades para medir la densidad y las setea en el store.
 *
 * @param {state, commit}
 * @returns {Promise<void>}
 * @author Luis Almendrales
 */
export async function getDensityUnits({ state, commit }) {
    commit("dashboard/load", true, { root: true });
    await $http
        .get(`adm_general/control-por-codigo/mostrar/UNIDEN`)
        .then(response => {
            commit("dashboard/load", false, { root: true });
            commit("setDensityUnits", response.data.data);
        })
        .catch(error => {
            commit("dashboard/load", false, { root: true });
            Swal.fire({
                position: "center",
                icon: "error",
                title: error.message + "<br />" + error.errors,
                showConfirmButton: true,
                timer: 5000
            });
        });
}

/**
 * Método para setear el valor de la ubicacion seleccionada.
 *
 * @param {state, commit}
 * @param {object} data
 * @returns {Promise<void>}
 * @author Luis Almendrales
 */
export function setLocationSelected({ state, commit }, data) {
    commit("setLocation", data);
}

/**
 * Método para guardar un producto en el accidente mayor.
 *
 * @param {*} state
 * @param {*} commit
 * @param {*} data
 * @returns {Promise<void>}
 * @author Luis Almendrales
 */
export async function saveProduct({ state, commit }, data) {
    data.company_id = state.filter.company.id;
    commit("dashboard/load", true, { root: true });
    await $http
        .post("/slq-high-accident/add-product", data)
        .then(response => {
            commit("dashboard/load", false, { root: true });
            Swal.fire({
                title: "Producto guardado",
                text: response.data.message,
                icon: "success",
                confirmButtonText: "Aceptar"
            });
        })
        .catch(error => {
            commit("dashboard/load", false, { root: true });
            Swal.fire({
                title: "Error al guardar el producto",
                text: error.response.data.message,
                icon: "error",
                confirmButtonText: "Aceptar"
            });
        });
}

/**
 * Método para inactivar un producto del accidente mayor.
 *
 * @param {*} state
 * @param {*} commit
 * @param {*} data
 * @returns {Promise<void>}
 * @author Luis Almendrales
 */
export async function deleteProduct(
    { state, commit, rootState, dispatch },
    data
) {
    Swal.fire({
        title: "Cambiar estado",
        text: "¿Está seguro de eliminar este producto?",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "Cancelar",
        confirmButtonText: "Si"
    }).then(async result => {
        if (result.value) {
            commit("dashboard/load", true, { root: true });

            await $http
                .put(`slq-high-accident/delete-product/${data.id}`, data)
                .then(async response => {
                    commit("dashboard/load", false, { root: true });
                    await Swal.fire({
                        position: "center",
                        icon: "success",
                        title: "Muy bien!",
                        text: response.data.message,
                        showConfirmButton: true,
                        timer: 2000
                    });
                    await dispatch("getProductsByLocationId", {
                        id: data.high_accident_id,
                        location_id: state.location.id,
                        compnay_id: data.company_id
                    });
                })
                .catch(error => {
                    commit("dashboard/load", false, { root: true });
                    Swal.fire({
                        position: "center",
                        icon: "error",
                        title: error.message,
                        showConfirmButton: true,
                        timer: 5000
                    });
                });
        }
    });
}

/**
 * Método para obtener el resumen de un accidente mayor.
 *
 * @param {state}
 * @param {commit}
 * @param {id} id del accidente mayor
 * @returns {Promise<void>}
 * @author Luis Almendrales
 */
export async function getSummary({ state, commit }, id) {
    commit("dashboard/load", true, { root: true });
    await $http
        .get(
            `slq-high-accident/summary/${id}?company_id=${state.filter.company.id}`
        )
        .then(response => {
            commit("setSummary", response.data.data);
            commit("dashboard/load", false, { root: true });
        })
        .catch(error => {
            commit("dashboard/load", false, { root: true });
            Swal.fire({
                position: "center",
                icon: "error",
                title: error.message,
                showConfirmButton: true,
                timer: 5000
            });
        });
}

/**
 * Método para obtener los fabricantes por su nombre.
 *
 * @param {state, commit}
 * @param {string} name
 * @returns {Promise<void>}
 * @author Luis Almendrales
 */
export async function getProducerByName({ state, commit }, name) {
    if (name.length >= 3) {
        commit("dashboard/load", true, { root: true });
        await $http
            .get(`fabricantes?nombre=${name}`)
            .then(response => {
                commit("dashboard/load", false, { root: true });
                commit("setProducers", response.data.fabricantes);
            })
            .catch(error => {
                commit("dashboard/load", false, { root: true });
                Swal.fire({
                    position: "center",
                    icon: "error",
                    title: error.message,
                    showConfirmButton: true,
                    timer: 5000
                });
            });
    }
}

/**
 * Método para buscar la empresa por el di
 *
 * @param {state, commit}
 * @returns {Promise<void>}
 * @author Luis Almendrales
 */
export async function getCompanyById({ state, commit }) {
    commit("dashboard/load", true, { root: true });
    await $http
        .get(`/companies/show/${state.filter.company.id}`)
        .then(response => {
            commit("dashboard/load", false, { root: true });
            commit("setCompany", response.data.data);
        })
        .catch(error => {
            commit("dashboard/load", false, { root: true });
            Swal.fire({
                position: "center",
                icon: "error",
                title: error.message,
                showConfirmButton: true,
                timer: 5000
            });
        });
}

/**
 * Método para buscar productos no asignados a la empresa
 *
 * @param {state, commit}
 * @returns {Promise<void>}
 * @author Luis Almendrales
 */
export async function getPorductsNoAsigned({ state, commit }, name) {
    if (name.length >= 3) {
        commit("dashboard/load", true, { root: true });
        await $http
            .get(
                `slq-high-accident/get-products-no-asigned?company_id=${state.filter.company.id}&search=${name}&slq_high_accident_id=${state.accidentHighId}`
            )
            .then(response => {
                commit("dashboard/load", false, { root: true });
                commit("setProductsNoAsigne", response.data.data);
            })
            .catch(error => {
                commit("dashboard/load", false, { root: true });
                Swal.fire({
                    position: "center",
                    icon: "error",
                    title: error.message,
                    showConfirmButton: true,
                    timer: 5000
                });
            });
    }
}

/**
 * Método para guardar la asignación de los productos químicos a las empresas.
 *
 * @param {*} param0
 * @param {*} payload  contiene la información para la asignación.
 */
export async function storeAsigne(
    { commit, state, rootState, dispatch },
    payload
) {
    commit("dashboard/load", true, { root: true });
    await $http
        .post(
            `adm_productos/asignacion_basica/crear/${state.filterProductsNoAsigned.id}`,
            payload
        )
        .then(response => {
            commit("dashboard/load", false, { root: true });
            Swal.fire({
                position: "center",
                icon: "success",
                title: response.data.message,
                showConfirmButton: false,
                timer: 1500
            });
        })
        .catch(error => {
            commit("dashboard/load", false, { root: true });
            Swal.fire({
                position: "center",
                icon: "error",
                title: error.message + "<br> " + error.errors,
                showConfirmButton: true,
                timer: 2000
            });
        });
}

/**
 * Metodo para asignar producto a ubicacion.
 *
 * @param {*} param0
 * @param {*} data
 * @returns
 */
export async function storeLocation({ state, commit }, data) {
    let payload = {
        ubicaciones: data,
        id_empresa: state.filter.company.id
    };
    commit("dashboard/load", true, { root: true });
    await $http
        .post(
            `adm_productos/ubicaciones-masiva/${state.filterProductsNoAsigned.id}`,
            payload
        )
        .then(response => {
            commit("dashboard/load", false, { root: true });
            Swal.fire({
                position: "center",
                icon: "success",
                title: response.data.message,
                showConfirmButton: false,
                timer: 1500
            });
        })
        .catch(error => {
            commit("dashboard/load", false, { root: true });
            Swal.fire({
                position: "center",
                icon: "error",
                title: error.message + "<br> " + error.errors,
                showConfirmButton: true,
                timer: 2000
            });
        });
}

/**
 * Metodo para guardar propiedades de productos.
 *
 * @param {*} param0
 * @param {*} data
 * @returns promise
 */
export async function storePropertyProduct({ state, commit }, data) {
    commit("dashboard/load", true, { root: true });
    await $http
        .post(`product-property/create`, data)
        .then(response => {
            commit("dashboard/load", false, { root: true });
            Swal.fire({
                position: "center",
                icon: "success",
                title: response.data.message,
                showConfirmButton: false,
                timer: 1500
            });
        })
        .catch(error => {
            commit("dashboard/load", false, { root: true });
            Swal.fire({
                position: "center",
                icon: "error",
                title: error.message + "<br> " + error.errors,
                showConfirmButton: true,
                timer: 2000
            });
        });
}

/**
 * Metodo para actualizar propiedades de productos.
 *
 * @param {*} param0
 * @param {*} data
 * @returns promise
 * @author Luis Almendrales
 */
export async function updatePropertyProduct({ state, commit }, data) {
    commit("dashboard/load", true, { root: true });
    await $http
        .put(`product-property/update/${data.id}`, data)
        .then(response => {
            commit("dashboard/load", false, { root: true });
            Swal.fire({
                position: "center",
                icon: "success",
                title: response.data.message,
                showConfirmButton: false,
                timer: 1500
            });
        })
        .catch(error => {
            commit("dashboard/load", false, { root: true });
            Swal.fire({
                position: "center",
                icon: "error",
                title: error.message + "<br> " + error.errors,
                showConfirmButton: true,
                timer: 2000
            });
        });
}

/**
 * Metodo para descargar resultado de accidentes mayores la data llega en base64 y es un archivo pdf.
 *
 * @param number slq_high_accident_id
 * @returns promise
 * @autor Luis Almendrales
 */
export async function downloadResult(
    { commit, state, rootState, dispatch },
    {slq_high_accident_id, type}
) {
    const payload = {
        slq_high_accident_id,
        company_id: rootState.accidents_high.filter.company.id,
        slq_location_id: rootState.accidents_high.location.id,
        type
    };
    commit("dashboard/load", true, { root: true });
    await $http
        .post("slq-high-accident/generate-report", payload)
        .then(response => {
            commit("dashboard/load", false, { root: true });
            //Genera archivo apartir de base64 descargar.
            const linkSource = `data:application/pdf;base64,${response.data.data.file}`;
            const downloadLink = document.createElement("a");
            const fileName = response.data.data.name_file + `.${type}`;
            downloadLink.href = linkSource;
            downloadLink.download = fileName;
            downloadLink.click();
        })
        .catch(error => {
            commit("dashboard/load", false, { root: true });
            Swal.fire({
                position: "center",
                icon: "error",
                title: error.message + "<br> " + error.errors,
                showConfirmButton: true,
                timer: 2000
            });
        });
}

/**
 * Metodo para Inactivar productos de un accidente mayor.
 *
 * @param {ayyay} locations
 * @param {int} company_id
 * @param {int} product_id
 */
export async function inactivateProducts(
    { commit, state, rootState, dispatch },
    data
) {
    return new Promise(async (resolve, reject) => {
        commit("dashboard/load", true, { root: true });
        $http
            .post("slq-high-accident/validate-producto-by-location", data)
            .then(res => {
                commit("dashboard/load", false, {
                    root: true
                });
                if (res.data.data.length) {
                    Swal.fire({
                        title: "Inactivar producto",
                        text:
                            "Estás a punto de desasignar un producto de ubicaciones que están en un accidenten mayor al hacer esto automáticamente se eliminará del accidente mayor. ¿Estás seguro?",
                        icon: "question",
                        showCancelButton: true,
                        confirmButtonColor: "#3085d6",
                        cancelButtonColor: "#d33",
                        cancelButtonText: "Cancelar",
                        confirmButtonText: "Si"
                    }).then(async result => {
                        if (result.value) {
                            await $http
                                .post("slq-high-accident/activate", data)
                                .then(response => {
                                    commit("dashboard/load", false, {
                                        root: true
                                    });
                                    Swal.fire({
                                        position: "center",
                                        icon: "success",
                                        title: response.data.message,
                                        showConfirmButton: false,
                                        timer: 1500
                                    });
                                    resolve(response.data); // resuelve la promesa con la respuesta
                                })
                                .catch(error => {
                                    commit("dashboard/load", false, {
                                        root: true
                                    });
                                    Swal.fire({
                                        position: "center",
                                        icon: "error",
                                        title:
                                            error.message +
                                            "<br> " +
                                            error.errors,
                                        showConfirmButton: true,
                                        timer: 2000
                                    });
                                    reject(error); // rechaza la promesa con el error
                                });
                        } else {
                            reject(); // rechaza la promesa si el usuario cancela la acción
                        }
                    });
                }else{
                    resolve();
                }
            })
            .catch(err => {
                reject(err);
            });
    });
}

/**
 * Metodo para Listar productos inactivos ó movidos de un accidente mayor.
 *
 * @param {int} slq_high_accident_id
 * @param {int} company_id
 * @param {int} slq_location_id
 */
export async function listProductsInactives(
    { commit, state, rootState, dispatch },
    data
) {
    commit("dashboard/load", true, { root: true });
    await $http
        .get(
            "slq-high-accident/products-location-inactives/" +
                data.location_id +
                "?company_id=" +
                state.filter.company.id +
                "&high_accident_id=" +
                data.high_accident_id +
                "&page=" +
                state.filterProductsInactives.page +
                "&perPage=" +
                state.filterProductsInactives.perPage +
                "&search=" +
                state.filterProductsInactives.search
        )
        .then(response => {
            commit("dashboard/load", false, { root: true });
            commit("setProductsInactivePpam", response.data.data);
        })
        .catch(error => {
            commit("dashboard/load", false, { root: true });
            Swal.fire({
                position: "center",
                icon: "error",
                title: error.message + "<br> " + error.errors,
                showConfirmButton: true,
                timer: 2000
            });
        });
}

/**
 * Metodo para activar un producto en una ubicacion.
 *
 * @param {int} product_id
 * @param {int} location_id
 * @param {int} company_id
 */
export async function activateProduct(
    { commit, state, rootState, dispatch },
    data
) {
    return new Promise(async (resolve, reject) => {
        const payload = {
            product_id: data.product_id,
            location_id: data.location_id,
            company_id: data.company_id
        };

        commit("dashboard/load", true, { root: true });

        await $http
            .post(`products/add-or-update-location`, payload)
            .then(async response => {
                commit("dashboard/load", false, { root: true });
                await Swal.fire({
                    position: "center",
                    icon: "success",
                    title: response.data.message,
                    showConfirmButton: false,
                    timer: 1500
                });
                resolve(response.data);
            })
            .catch(error => {
                commit("dashboard/load", false, { root: true });
                reject(error);
            });
    });
}

/**
 * Aprobación de Accidentes mayores.
 *
 * @param Object { commit, dispatch }: manejo de estados y acciones.
 * @param Object payload: información del accidente.
 * @returns promise
 */
export async function approveMajorAccident({ commit, dispatch }, payload) {

    commit("dashboard/load", true, { root: true });

    await $http.put(`slq-high-accident/approve-major-accident`, payload)
        .then(({data: response}) => {

            commit('resetModalApprovalHighAccident')
            dispatch('getAccidentHigh')

            this.$vue.$alertSuccess(response.message)

        })
        .catch((error) => {
            if (this.$vue.$alertErrorsCallback(error)) return;
            this.$vue.$alertError(error.message);
        })
        .finally(() => commit('dashboard/load', false, { root: true }))
}

/**
 * Clonar Accidentes mayores.
 *
 * @param Object { commit, dispatch }: manejo de estados y acciones.
 * @param Object payload: información del accidente.
 * @returns promise
 */
export async function cloneHighAccident({ commit, dispatch }, payload) {

    commit("dashboard/load", true, { root: true });

    await $http.post(`slq-high-accident/clone-major-accident`, payload)
        .then(({data: response}) => {

            commit('resetModalCloneHighAccident')
            dispatch('getAccidentHigh')

            this.$vue.$alertSuccess(response.message)

        })
        .catch((error) => {
            if (this.$vue.$alertErrorsCallback(error)) return;
            this.$vue.$alertError(error.message);
        })
        .finally(() => commit('dashboard/load', false, { root: true }))
}

/**
 * Tabla comparativa de productos éliminados y actuales de un accidente mayor
 *
 * @returns {Promise<void>}
 * @author Paul Valencia
 */
export async function getProductsComparative({state, commit}, data) {
    try {
        commit('dashboard/load', true, {root: true});
        const payload = {
            company_id: data.company_id,
            high_accident_id: data.id,
            page: data.page,
            perPage: data.perPage,
            search: state.filterProducts.search,
            producer_id: state.filterProducts.producer.id,
            type: data.type,
        }
        const response = await $http.get(`/slq-high-accident/products-table-comparative/${data.location_id}`, {params: {...payload}});
        commit("setListComparative", response.data.data);
    } catch (error) {
        if (this.$vue.$alertErrorsCallback(error)) return;
        this.$vue.$alertError(error.message);
    } finally {
        commit('dashboard/load', false, {root: true});
    }
}
